import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.drop-down */
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { useThemeUI } from 'theme-ui';
import { TruCaret } from '@uswitch/spark-icons/tru';
import { FrozenInput } from '../frozen-input';
import { path } from '@uswitch/ev-utils/obj';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var prependDataProps = function prependDataProps(dataProps) {
  return Object.keys(dataProps).reduce(function (props, key) {
    return _objectSpread(_objectSpread({}, props), {}, _defineProperty({}, "data-".concat(key), dataProps[key]));
  }, {});
};

var DropDown = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$dataProps = _ref.dataProps,
      dataProps = _ref$dataProps === void 0 ? {} : _ref$dataProps,
      disabled = _ref.disabled,
      freezable = _ref.freezable,
      _ref$hasError = _ref.hasError,
      hasError = _ref$hasError === void 0 ? false : _ref$hasError,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      _onChange = _ref.onChange,
      _ref$onFocus = _ref.onFocus,
      _onFocus = _ref$onFocus === void 0 ? function () {} : _ref$onFocus,
      _ref$onClick = _ref.onClick,
      _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      name = _ref.name,
      options = _ref.options,
      placeholder = _ref.placeholder,
      value = _ref.value,
      overlay = _ref.overlay,
      className = _ref.className;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasFocus = _useState2[0],
      setHasFocus = _useState2[1];

  var option = options.find(function (_) {
    return _.value === value;
  });
  var frozenText = option && option.text;
  var inputRef = useRef(null);
  useImperativeHandle(ref, function () {
    return {
      focus: function focus() {
        return inputRef.current && inputRef.current.focus();
      },
      scrollIntoView: function scrollIntoView() {
        var _inputRef$current;

        return inputRef.current && (_inputRef$current = inputRef.current).scrollIntoView.apply(_inputRef$current, arguments);
      }
    };
  });
  var variant = hasError ? 'elements.drop-down.select.variants.error' : hasFocus ? 'elements.drop-down.select.variants.focus' : 'elements.drop-down.select.base';
  var iconColor = path("".concat(variant, ".iconColor").split('.'), theme) || path('elements.drop-down.select.base.iconColor'.split('.'), theme) || path("".concat(variant, ".borderColor").split('.'), theme) || path('elements.drop-down.select.base.borderColor'.split('.'), theme);
  return _jsx(FrozenInput, {
    text: frozenText,
    freezable: freezable,
    inputRef: inputRef,
    children: _jsxs("div", {
      sx: {
        position: 'relative',
        variant: 'elements.drop-down.container'
      },
      children: [overlay ? _jsx("div", {
        sx: {
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          paddingX: 16,
          variant: variant
        },
        className: className,
        children: overlay
      }) : null, _jsxs("select", _objectSpread(_objectSpread({
        ref: inputRef,
        onFocus: function onFocus() {
          setHasFocus(true);

          _onFocus();
        },
        onBlur: function onBlur() {
          setHasFocus(false);

          _onBlur();
        },
        onChange: function onChange(e) {
          return _onChange(e.currentTarget.value);
        },
        onClick: function onClick() {
          return _onClick();
        },
        sx: {
          opacity: overlay ? 0 : undefined,
          fontFamily: 'base',
          fontSize: 'base',
          lineHeight: '1.33',
          appearance: 'none',
          backgroundColor: 'white',
          boxSizing: 'border-box',
          padding: 16,
          paddingRight: 48,
          verticalAlign: 'middle',
          borderRadius: 0,
          width: '100%',
          '&::-ms-expand': {
            display: 'none'
          },
          height: '100%',
          variant: placeholder && value === undefined ? 'elements.drop-down.placeholder' : variant
        },
        id: name,
        name: name,
        className: className,
        value: !value ? '' : value,
        disabled: disabled
      }, prependDataProps(dataProps)), {}, {
        children: [placeholder ? _jsx("option", {
          value: "",
          disabled: true,
          children: placeholder
        }) : null, options.map(function (propOption, index) {
          return _jsx("option", {
            value: propOption.value,
            children: propOption.text
          }, propOption.text);
        }, this)]
      })), !overlay ? _jsx("span", {
        sx: {
          height: 15,
          width: 15,
          pointerEvents: 'none',
          position: 'absolute',
          right: 16,
          top: 'calc(50% - 15px / 2)',
          variant: 'elements.drop-down.icon'
        },
        children: _jsx(TruCaret, {
          color: iconColor,
          sx: {
            transform: 'rotate(0.5turn)'
          }
        })
      }) : null]
    })
  });
});
export default DropDown;
//# sourceMappingURL=index.js.map